(function() {
    'use strict';

    angular
        .module('claimsApp',['corePRUGAGreatApp','ui.select','ngSanitize','ngTable','taskApp','angular-confirm','signatureApp','historyApp'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();